$(document).ready(function () {
  function sliderFun(
    sliderclass,
    progressBarclass,
    progresslabel,
    arrowleft,
    arrowright,
    desktop,
    tablet,
    mobile,
    smalldevice
  ) {
    let $slider = $(sliderclass);
    let $progressBar = document.querySelector(progressBarclass);
    let $progressBarLabel = document.querySelector(progresslabel);

    // let $slider = $(".trandSlider");
    // let $progressBar = document.querySelector(".wrpTrnd .progress");
    // let $progressBarLabel = document.querySelector(".wrpTrnd .slider__label");

    function updateProgressBar(currentSlide, slick) {
      let slidesToShow = slick.options.slidesToShow;
      let totalSteps = slick.slideCount - slidesToShow;
      totalSteps = totalSteps <= 0 ? 1 : totalSteps;

      let percentage = (currentSlide / totalSteps) * 100;
      percentage = Math.min(100, Math.max(0, percentage)); // Clamp between 0-100

      if ($progressBar) {
        $progressBar.style.setProperty("--background-size", `${percentage}%`);
        $progressBar.setAttribute("aria-valuenow", percentage);
      }

      if ($progressBarLabel) {
        $progressBarLabel.textContent = `${Math.round(percentage)}% completed`;
      }
    }

    $slider.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        updateProgressBar(nextSlide, slick);
      }
    );

    $slider.on("init", function (event, slick) {
      updateProgressBar(0, slick);
    });

    $slider.slick({
      slidesToShow: desktop,
      slidesToScroll: 1,
      infinite: false,
      speed: 400,
      prevArrow: $(arrowleft),
      nextArrow: $(arrowright),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: tablet,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: mobile,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: smalldevice,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
    });
  }

  sliderFun(
    ".trandSlider", // Slider ke element ka class
    ".wrpTrnd .progress", // Progress bar element
    ".wrpTrnd .slider__label", // Progress bar text label
    ".wrpTrnd .left_arrow", // Left arrow button
    ".wrpTrnd .right_arrow", // Right arrow button
    2.5, // Desktop slidesToShow = 2.5
    2, // Tablet slidesToShow = 2
    1, // Mobile slidesToShow = 1
    1 // Small device slidesToShow = 1
  );

  // -----------------Review Slider----------------------

  sliderFun(
    ".revSlider", // Slider ke element ka class
    ".revwrapper .progress", // Progress bar element
    ".revwrapper .slider__label", // Progress bar text label
    ".revslider .left_arrow", // Left arrow button
    ".revslider .right_arrow", // Right arrow button
    4.5, // Desktop slidesToShow = 4.5
    3, // Tablet slidesToShow = 3
    2, // Mobile slidesToShow = 2
    2 // Small device slidesToShow = 1
  );

  // -----------------About Family Slider----------------------

  sliderFun(
    ".famSlider", // Slider ke element ka class
    ".family-slider .progress", // Progress bar element
    ".family-slider .slider__label", // Progress bar text label
    ".family-slider .left_arrow", // Left arrow button
    ".family-slider .right_arrow", // Right arrow button
    3, // Desktop slidesToShow = 3
    3, // Tablet slidesToShow = 3
    2, // Mobile slidesToShow = 2
    1 // Small device slidesToShow = 1
  );



  
  //------- product details tab section--------

  const tabWrapper = document.querySelector(".tabswrapper .tabs");

  if (!tabWrapper) return; // Stop execution if the tab section doesn't exist

  const tabButtons = tabWrapper.querySelectorAll("[role='tab']");
  const tabPanels = Array.from(
    tabWrapper.querySelectorAll("[role='tabpanel']")
  );

  function tabClickHandler(e) {
    tabPanels.forEach((panel) => (panel.hidden = true));
    tabButtons.forEach((button) =>
      button.setAttribute("aria-selected", "false")
    );

    e.currentTarget.setAttribute("aria-selected", "true");
    const selectedTab = tabPanels.find(
      (panel) => panel.getAttribute("aria-labelledby") === e.currentTarget.id
    );
    if (selectedTab) selectedTab.hidden = false;
  }

  tabButtons.forEach((button) =>
    button.addEventListener("click", tabClickHandler)
  );


  



  // document end
});



$(document).ready(function(){
  $("variant-selects .product-form__input label").click(function(){
    console.log(window.location.href); // or location.pathname
  });
});

